import React, { lazy, Suspense } from 'react';
import {
  Router, Route, Switch,
} from 'react-router-dom';
import history from '../history';

import LoadingProgress from '../components/loading-progress';
import SystemError from '../pages/system-error';
import ErrorBoundary from '../components/error-boundary';

const Forbidden = lazy(() => import(/* webpackChunkName: "403" */ '../pages/403'));
const NotFound = lazy(() => import(/* webpackChunkName: "404" */ '../pages/404'));
const Logout = lazy(() => import(/* webpackChunkName: "logout" */ '../pages/logout'));
const HomePage = lazy(() => import(/* webpackChunkName: "home" */ '../pages/home'));
const RouteListener = lazy(() => import(/* webpackChunkName: "route-listener" */ '../framework/route-listener'));
const RouteJwt = lazy(() => import(/* webpackChunkName: "route-jwt" */ '../framework/route-jwt'));

const Routes = () => (
  <Suspense fallback={<LoadingProgress open />}>
    <Router history={history}>
      <ErrorBoundary>
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/403" component={Forbidden} />
          <Route exact path="/404" component={NotFound} />
          <Route exact path="/error" component={SystemError} />
          <Route exact path="/logout" component={Logout} />
          <Route path="/jwt" component={RouteJwt} />
          <Route component={RouteListener} />
        </Switch>
      </ErrorBoundary>
    </Router>
  </Suspense>
);

export default Routes;
